var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3896 31C29.1857 31 29.8311 30.3604 29.8311 29.5714C29.8311 28.7824 29.1857 28.1429 28.3896 28.1429C27.5934 28.1429 26.948 28.7824 26.948 29.5714C26.948 30.3604 27.5934 31 28.3896 31Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.695 30.9195C13.4911 30.9195 14.1365 30.2799 14.1365 29.4909C14.1365 28.7019 13.4911 28.0623 12.695 28.0623C11.8988 28.0623 11.2534 28.7019 11.2534 29.4909C11.2534 30.2799 11.8988 30.9195 12.695 30.9195Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H6.76623L10.6296 20.1285C10.7614 20.7863 11.1225 21.3771 11.6496 21.7975C12.1767 22.218 12.8362 22.4414 13.5127 22.4285H27.5246C28.2012 22.4414 28.8607 22.218 29.3878 21.7975C29.9149 21.3771 30.2759 20.7863 30.4078 20.1285L32.7142 8.14285H8.20778"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ad3fc9df90411ed395bcbd1e04a8ed20.svg";
export { ForwardRef as ReactComponent };